import React from "react";
import { Table, Row, Col } from "react-bootstrap";

export default function TableLarge(props) {
  const { dataDokter } = props;
  return (
    <Row>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Minggu</strong>
              </th>
            </tr>
            {dataDokter?.rows[0]?.length > 0 ? (
              <>
                {dataDokter?.rows[0]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Senin</strong>
              </th>
            </tr>
            {dataDokter?.rows[1]?.length > 0 ? (
              <>
                {dataDokter?.rows[1]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Selasa</strong>
              </th>
            </tr>
            {dataDokter?.rows[2]?.length > 0 ? (
              <>
                {dataDokter?.rows[2]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Rabu</strong>
              </th>
            </tr>
            {dataDokter?.rows[3]?.length > 0 ? (
              <>
                {dataDokter?.rows[3]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Kamis</strong>
              </th>
            </tr>
            {dataDokter?.rows[4]?.length > 0 ? (
              <>
                {dataDokter?.rows[4]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Jum'at</strong>
              </th>
            </tr>
            {dataDokter?.rows[5]?.length > 0 ? (
              <>
                {dataDokter?.rows[5]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
      <Col lg="4">
        <Table bordered hover responsive>
          <tbody>
            <tr>
              <th
                colSpan="2"
                style={{ backgroundColor: "#4CAF50", color: "white" }}
              >
                <strong>Sabtu</strong>
              </th>
            </tr>
            {dataDokter?.rows[6]?.length > 0 ? (
              <>
                {dataDokter?.rows[6]?.map((obj, idx) => (
                  <tr key={idx}>
                    <td>{obj?.jam === "-" ? "Sepanjang Hari" : obj?.jam}</td>
                    <td>{obj?.namadokter}</td>
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                <td colSpan="2">Tidak ada jadwal pada hari ini...</td>
              </tr>
            )}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
}
